import Map from '../assorted/Map';
import VideoPlayer from '../assorted/VideoPlayer';

export default class Privacy {
    constructor() {
        this.el = null;
    }

    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.m = new Map();
        this.v = new VideoPlayer();
        this.buildHtml();
        this.bindOptOutLink(el);
        //this.isMapCookieActive();
        //this.mapCookieToggler();
        //this.isYoutubeVideoCookieActive();
        //this.isVimeoVideoCookieActive();
        //this.videoCookieToggler();
    }

    bindOptOutLink() {
        this.el.addEventListener(
            'click',
            (e) => {
                if (e.target.matches('.ga-disable, ga-disable *')) {
                    alert('Google Analytics wurde deaktiviert');
                    document.cookie =
                        'ga-disable=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
                    e.preventDefault();
                }
            },
            true
        );
    }

    mapCookieToggler() {
        this.el.querySelector('.contact__map-optinout-toggler').addEventListener('click', () => {
            if (this.m.getCookie()) {
                this.m.deleteCookie();
            } else {
                this.m.setCookie();
            }
        });
    }

    isMapCookieActive() {
        this.el.querySelector('.contact__map-optinout-toggler').checked = this.m.getCookie();
    }

    videoCookieToggler() {
        this.el.querySelectorAll('.video__optinout-toggler').forEach((el__value) => {
            el__value.addEventListener('click', (e) => {
                let el = e.target;
                if (this.v.getCookie(el.getAttribute('data-provider'))) {
                    this.v.deleteCookie(el.getAttribute('data-provider'));
                } else {
                    this.v.setCookie(el.getAttribute('data-provider'));
                }
            });
        });
    }

    isYoutubeVideoCookieActive() {
        this.el.querySelector('.youtube__optinout-toggler').checked = this.v.getCookie('youtube');
    }

    isVimeoVideoCookieActive() {
        this.el.querySelector('.vimeo__optinout-toggler').checked = this.v.getCookie('vimeo');
    }

    buildHtml() {
        let dom = this.el.querySelector('.legal-text'),
            company = JSON.parse(decodeURIComponent(dom.getAttribute('data-company'))),
            socials =
                company.socials === null || company.socials === undefined
                    ? []
                    : Object.values(company.socials)
                          .filter((i) => i.visible === true)
                          .map((i) => i.data.name),
            /*
            hasPackageBasic = JSON.parse(
                decodeURIComponent(dom.getAttribute('data-has-package-basic'))
            ),
            uiTextGoogleMapOptInOut = JSON.parse(
                decodeURIComponent(dom.getAttribute('data-gmap-optinout-text'))
            ),
            uiTextYoutubeVideoOptInOut = JSON.parse(
                decodeURIComponent(dom.getAttribute('data-youtube-optinout-text'))
            ),
            uiTextVimeoVideoOptInOut = JSON.parse(
                decodeURIComponent(dom.getAttribute('data-vimeo-optinout-text'))
            ),
            */

            // ==============================================================
            // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
            //
            // also update tecpage-files/_coming_soon.php
            // when changing the privacy notes
            //
            // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
            // ==============================================================
            html =
                `
            <div class="privacy__inner-row module__inner-row">
                <div class="privacy__legal-text-col module__inner-col module__cms">
                    <h2 class="privacy__title module__title font-h2 color-h2">DATENSCHUTZ&shy;INFORMA&shy;TIONEN</h2>
                    <p>
                    Unsere Datenschutzinformationen sind wie folgt gegliedert:
                    </p>
                    <strong>A. Allgemeine Informationen</strong>
                    <p>
                    I. Verantwortlicher<br />
                    ` +
                (company.privacy_officer.needed == '1' ? `II. Datenschutzbeauftragter<br />` : ``) +
                `` +
                (company.privacy_officer.needed == '1' ? `III.` : `II.`) +
                ` Weitergabe von Daten an Dritte<br />
                    ` +
                (company.privacy_officer.needed == '1' ? `IV.` : `III.`) +
                ` Speicherdauer<br />
                    ` +
                (company.privacy_officer.needed == '1' ? `V.` : `IV.`) +
                ` Ihre Rechte<br />
                    </p>
                    <strong>B. Unbedingt erforderliche Datenverarbeitung zur Bereitstellung unserer Websiten</strong>
                    <br />
                    <br />
                    <strong>C. Datenverarbeitung bei einer Kontaktaufnahme</strong>
                    <p>
                    I. Kontaktaufnahme<br />
                    II. Werbemaßnahmen<br />
                    </p>
                    ` +
                (socials.length > 0
                    ? `
                    <strong>D. Ergänzende Informationen zur Datenverarbeitung auf unseren Social Media Unternehmensseiten</strong>
                    <p>
                    I. Allgemein zu Unternehmensseiten, Rechtsgrundlage<br />
                    II. Vereinbarungen nach Art. 26 DSGVO<br />
                    </p>
                    `
                    : ``) +
                `
                    <strong>` +
                (socials.length > 0 ? `E.` : `D.`) +
                ` Ergänzende Informationen für Bewerber</strong>
                    <p>
                    I. Zweck und Rechtsgrundlage der Verarbeitung personenbezogener Daten unserer Bewerber<br />
                    II. Löschung von Bewerberdaten<br />
                    </p>
                    <p>
                    Aus Gründen der besseren Lesbarkeit wird auf die gleichzeitige Verwendung männlicher und weiblicher Sprachformen verzichtet. Sämtliche Bezeichnungen gelten für alle Geschlechter.
                    </p>
                    <h2 class="privacy__title module__title font-h2 color-h2">A. Allgemeine Informationen</h2>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">I. Verantwortlicher</h3>
                    <p>
                    Verantwortlich für die Verarbeitung personenbezogener Daten ist:
                    </p>
                    <p>
                        ${company.firma1}<br />
                        ` +
                (company.firmierung !== undefined &&
                company.firmierung !== null &&
                company.firmierung !== ''
                    ? `${company.firmierung}<br />`
                    : ``) +
                `
                        ${company.strasse}<br />
                        ${company.plz} ${company.ort}<br />
                        ${company.land}
                    </p>
                    <p>Telefon: <a href="tel:${company.telefon}" class="module__link--underlined">${company.telefon}</a><br />
                    E-Mail: <a href="mailto:${company.email}" class="module__link--underlined">${company.email}</a></p>
                    ` +
                (company.privacy_officer.needed == '1'
                    ? `
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">II. Datenschutzbeauftragter</h3>
                    <p>
                    Unseren Datenschutzbeauftragten erreichen Sie unter:
                    </p>
                    <p>${company.privacy_officer.first_name} ${company.privacy_officer.last_name}<br />
                        Telefon: <a href="tel:${company.privacy_officer.phone}" class="module__link--underlined">${company.privacy_officer.phone}</a><br />
                    E-Mail: <a href="mailto:${company.privacy_officer.email}" class="module__link--underlined">${company.privacy_officer.email}</a></p>`
                    : ``) +
                `
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">
                    ` +
                (company.privacy_officer.needed == '1' ? `III.` : `II.`) +
                ` Weitergabe von Daten an Dritte</h3>
                    <p>
                    Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur, soweit das Datenschutzrecht eine solche zulässt, insbesondere sofern Sie in die Weitergabe eingewilligt haben (Art. 6 Abs. 1 S. 1 lit. a DSGVO) oder die Weitergabe zum Zweck der Vertragsabwicklung (Art. 6 Abs. 1 S. 1 lit. b DSGVO) erforderlich ist.
                    </p>
                    <p>
                    Kategorien von weisungsgebundenen und gemäß den datenschutzrechtlichen Vorgaben verpflichteten Dienstleistern, die die Daten nicht zu einem anderen Zweck verwenden dürfen, sind Dienstleister für die Betreuung und das Hosting der Website:
                    </p>
                    <ul>
                    <li><a href="https://deha.de/" target="_blank">DEHA Elektrohandelsgesellschaft mbH & Co. KG, Weilimdorfer Str. 74/2, 70839 Gerlingen</a></li>
                    <li><a href="https://close2.de/" target="_blank">close2 new media GmbH, Alpenstraße 35b, 82538 Geretsried </a></li>
                    <li><a href="https://all-inkl.com/" target="_blank">ALL-INKL.COM - Neue Medien Münnich, Hauptstraße 68, 02742 Friedersdorf</a></li>
                    </ul>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">
                     ` +
                (company.privacy_officer.needed == '1' ? `IV.` : `III.`) +
                ` Speicherdauer</h3>
                    <p>
                    Die durch uns verarbeiteten personenbezogenen Daten werden bei uns so lange gespeichert, wie dies für den jeweiligen Zweck – insbesondere der Bearbeitung Ihres Anliegens oder Ihres Auftrags – unter Beachtung der gesetzlichen Aufbewahrungsfristen (z. B. gemäß Handelsgesetzbuch und Abgabenordnung zehn Jahre für steuerrelevante Unterlagen bzw. sechs Jahre für sonstige Geschäftsbriefe) erforderlich ist (Art. 6 Abs. 1 S. 1 lit. c DSGVO). Eine über die gesetzlichen Aufbewahrungsfristen hinausgehende Speicherung ist möglich, wenn Sie hierin nach Art. 6 Abs. 1 S. 1 lit. a DSGVO eingewilligt haben oder der Zweck der Datenverarbeitung noch nicht entfallen ist.
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">
                    ` +
                (company.privacy_officer.needed == '1' ? `V.` : `IV.`) +
                ` Ihre Rechte</h3>
                    <p>
                    <strong>
                    1. Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung und Übertragbarkeit
                    </strong>
                    </p>
                    <p>
                    Sie haben unter den Voraussetzungen der Art. 15 bis 20 DSGVO das Recht, unentgeltlich Auskunft über die von uns zu Ihrer Person gespeicherten Daten zu erhalten, unrichtige Daten berichtigen zu lassen und die Löschung oder Einschränkung der Verarbeitung sowie die Übertragbarkeit Ihrer personenbezogenen Daten zu verlangen. In manchen Fällen dürfen wir Nutzerdaten allerdings wegen gesetzlicher Aufbewahrungspflichten nicht vollständig löschen.
                    </p>
                    <p>
                    <strong>
                    2. Widerspruchsrecht
                    </strong>
                    </p>
                    <p>
                    <strong>
                    Der Nutzung personenbezogener Daten für Zwecke der Direktwerbung können Sie jederzeit widersprechen; der Nutzung personenbezogener Daten auf der Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO können Sie aus Gründen, die sich aus Ihrer besonderen Situation ergeben, ebenfalls jederzeit mit Wirkung für die Zukunft widersprechen. Für den Widerspruch entstehen nur die Übermittlungskosten nach den Basistarifen. Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt hiervon unberührt.
                    </strong>
                    </p>
                    <p>
                    <strong>
                    3. Widerrufsrecht
                    </strong>
                    </p>
                    <p>
                    Soweit wir Daten aufgrund Ihrer Einwilligung verarbeiten, können Sie die Einwilligung in die Durchführung dieser Verarbeitungsvorgänge jederzeit mit Wirkung für die Zukunft durch Nachricht an die oben aufgeführten Kontaktdaten widerrufen. Der Widerruf einer zunächst erteilten Einwilligung hat keine Auswirkung auf die Rechtmäßigkeit der Datenverarbeitung bis zum Zeitpunkt des Widerrufs.
                    </p>
                    <p>
                    <strong>
                    4. Beschwerderecht
                    </strong>
                    </p>
                    <p>
                    Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts eines mutmaßlichen Verstoßes, wenn Sie Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen Datenschutzrecht verstößt. Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift können Sie <a href="https://www.bfdi.bund.de/DE/Service/Anschriften/anschriften_table.html" target="_blank">hier</a> aufrufen.
                    </p>
                    <h2 class="privacy__title module__title font-h2 color-h2">B. Unbedingt erforderliche Datenverarbeitung zur Bereitstellung unserer Webseiten</h2>
                    <p>
                    Um Inhalte unserer Webseiten abzurufen und diese korrekt auf Ihrem Endgerät darzustellen, sendet Ihr Browser automatisch Datenanfragen an unsere Server. Jede Datenanfrage Ihres Browsers beinhaltet dabei unter anderem diese Informationen: (dynamische) IP-Adresse, Browsertyp und Version, Betriebssystem und Version, aufgerufene Domain, zuvor besuchte Webseite sowie Datum und Uhrzeit des Zugriffs. Die Datenanfragen Ihres Browsers werden automatisch in sogenannten "Server Log Dateien" gespeichert.
                    </p>
                    <p>
                    Die dargestellte Datenverarbeitung ist unbedingt erforderlich, um die Abrufbarkeit sowie die korrekte Darstellung unserer Webseiten auf Ihrem Endgerät zu gewährleisten. Zudem können anhand der Log-Dateien Cyberangriffe ausgemacht und dadurch die Abrufbarkeit unserer Webseiten sichergestellt werden. Die Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                    </p>`;

        // ==============================================================
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        //
        // also update tecpage-files/_coming_soon.php
        // when changing the privacy notes
        //
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        // ==============================================================
        /*
            <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">3. Weitere Verarbeitung personenbezogener Daten auf unserer Website</h3>
            <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">a. Google Dienste</h3>
            <p>Soweit Sie eingewilligt haben, nutzt diese Website Dienste, die von Google Ireland Limited, Google Building Gordon House, 4 Barrow Street, Dublin, D04 E5W5, Irland ("Google") erbracht werden.
            </p>
            <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">aa.	Allgemein zu den Google Diensten, Rechtsgrundlage</h3>
            <p>Um die Dienste erbringen zu können, verarbeitet Google personenbezogene Daten. Die Rechtsgrundlage der Datenverarbeitung durch die Google-Dienste ist Ihre Einwilligung, Art. 6 Abs. 1 S. 1 lit. a DSGVO.
            </p>
            <p>Es kann nicht ausgeschlossen werden, dass durch Google-Dienste erhobene Informationen auch an einen Server von Google in einem Drittland, insbesondere an einen Server der Muttergesellschaft von Google, Google LLC mit Sitz in 1600 Amphitheatre Parkway, Mountain View, Kalifornien, USA, übermittelt und dort gespeichert werden. Google LLC verfügt über eine Zertifizierung nach dem "EU-US-Privacy-Shield" (unter https://www.privacyshield.gov/list unter dem Suchbegriff "Google" zu finden). Der "Privacy-Shield" ist ein Übereinkommen zwischen der Europäischen Union (EU) und den USA, das die Einhaltung europäischer Datenschutzstandards in den USA gewährleisten soll.
            </p>
            <p>Wenn Sie in Ihrem Google-Konto angemeldet sind, kann Google verarbeitete Informationen abhängig von Ihren Kontoeinstellungen Ihrem Konto hinzufügen und als personenbezogene Daten behandeln, vgl. hierzu insbesondere <a href="https://www.google.de/policies/privacy/partners/" target="_blank" rel="noopener" class="module__link--underlined">https://www.google.de/policies/privacy/partners/</a>. Wir erhalten keine Kenntnis über die auf diese Art gesammelten Daten und deren Verwendung.
            </p>
            <p>Weitere Informationen zur Datenverarbeitung durch Google finden Sie unter:
            </p>
            <ul>
            <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener" class="module__link--underlined">https://policies.google.com/privacy</a> ("Google-Datenschutzerklärung")</li>
            <li><a href="https://www.google.com/intl/de/policies/privacy/partners" target="_blank" rel="noopener" class="module__link--underlined">https://www.google.com/intl/de/policies/privacy/partners</a> ("Datennutzung durch Google bei Ihrer Nutzung von Websites oder Apps unserer Partner")</li>
            <li><a href="http://www.google.com/policies/technologies/ads" target="_blank" rel="noopener" class="module__link--underlined">http://www.google.com/policies/technologies/ads</a> ("Datennutzung zu Werbezwecken")</li>
            </ul>
            <br />
            <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">bb.	Google Maps</h3>
            <p>Diese Website nutzt Google Maps, um geographische Informationen visuell darzustellen und Anfahrtsbeschreibungen zu erstellen.
            </p>
            <p>Die Einbettung von Google Maps erfolgt über das sogenannte "Doppelklick-Verfahren". Somit wird Ihnen auf unserer Website zunächst nur ein Vorschaubild angezeigt, ohne dass hierdurch eine Verbindung zu Google hergestellt wird. Erst nachdem Sie durch einen Klick auf das jeweilige Vorschaubild die Kartenfunktion aktiviert haben, wird eine Verbindung zu Google aufgebaut. Dadurch wird Ihre IP-Adresse an die Server von Google weitergeleitet und Google somit darüber informiert, dass unsere Internetseite mit Ihrer IP-Adresse besucht wurde. Zudem kann Google nach eigenen Angaben durch Cookies, also durch kleine Textdateien, die auf Ihrem Rechner gespeichert werden, Daten zu Ihrem Nutzerverhalten erheben.
            </p>
            <p>Sie haben auch die Möglichkeit, den Service von Google Maps zu deaktivieren und somit den Datentransfer an Google zu verhindern, indem Sie über Ihre Browser-Einstellungen JavaScript deaktivieren. Wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall die Kartenanzeige nicht nutzen können.
            </p>
            <p>Weitere Informationen zu Google Maps finden Sie unter: <a href="https://www.google.com/intl/de_de/help/terms_maps.html" target="_blank" rel="noopener" class="module__link--underlined">https://www.google.com/intl/de_de/help/terms_maps.html</a> (Nutzungsbedingungen für Google Maps).
            </p>
            <span class="contact__map-optin-toggler-wrap">
            <input
                type="checkbox"
                id="contact__map-optinout-toggler"
                class="contact__map-optinout-toggler"
                name="contact__map-optinout-toggler"
                />
            <label
                class="contact__map-optinout-toggler-label"
                for="contact__map-optinout-toggler"
                >${uiTextGoogleMapOptInOut}
           </label>
            </span>
            ${
                hasPackageBasic === true
                    ? `
                <br>
                <br>
                <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">cc.	YouTube</h3>
                <p>Wir haben Videos des Google-Dienstes YouTube eingebunden, damit Sie diese auf unserer Website ansehen können.
                </p>
                <p>Die Einbettung der Videos erfolgt über den sogenannten "erweiterten Datenschutzmodus". Nach Angabe von Google werden beim Öffnen einer Webseite mit einem auf diese Weise eingebundenen Video zunächst keine Cookies zur Analyse des Nutzerverhaltens gesetzt. Erst nachdem Sie durch einen Klick auf das jeweilige Vorschaubild das Abspielen des Videos aktiviert haben, wird eine Verbindung zu Google aufgebaut. Dadurch wird Ihre IP-Adresse an die Server von Google weitergeleitet und Google somit darüber informiert, dass unsere Internetseite mit Ihrer IP-Adresse besucht wurde. Zudem kann Google nach eigenen Angaben durch Cookies Daten zu Ihrem Nutzerverhalten erheben.
                </p>
                <p>Ob durch Google nach Öffnen der Webseite schon vor Abspielen eines Videos personenbezogene Daten erhoben und verarbeitet werden, ist uns nicht bekannt.
                </p>
                <p>Sie haben die Möglichkeit, die Einbindung von YouTube-Videos und somit den Datentransfer an Google zu verhindern, indem Sie über Ihre Browser-Einstellungen JavaScript deaktivieren. Wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall die Videofunktion nicht nutzen können.
                </p>
                <p>Weitere Informationen zu YouTube finden Sie unter: <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener" class="module__link--underlined">https://www.youtube.com/t/terms</a> (Nutzungsbedingungen von YouTube).
                </p>
                <span class="video__optin-toggler-wrap">
                <input
                    type="checkbox"
                    id="youtube__optinout-toggler"
                    class="video__optinout-toggler youtube__optinout-toggler"
                    name="video__optinout-toggler youtube__optinout-toggler"
                    data-provider="youtube"
                    />
                <label
                    class="video__optinout-toggler-label youtube__optinout-toggler-label"
                    for="youtube__optinout-toggler"
                    >${uiTextYoutubeVideoOptInOut}
                </label>
                </span>
                <br />
                <br />
                <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">b. Vimeo</h3>
                <p>Sie können Sie auf unserer Website Videos von Vimeo (Vimeo, Inc., 555 West 18th Street, New York, New York 10011, USA) abspielen.
                </p>
                <p>Die Einbettung der Videos erfolgt im sogenannten "Do-Not-Track-Modus". Dieser Modus bewirkt laut Vimeo, dass bei Wiedergabe eines Videos keine Datenverarbeitung zur aktuellen Session erfolgt. Die Wirkung ist nach Angabe von Vimeo vergleichbar mit der Aktivierung eines "Do-Not-Track-Headers" im Browser. Demnach werden über die Aktivitäten Ihres Besuches auf unserer Website durch Vimeo keine Nutzungsprofile erstellt.
                </p>
                <p>Vimeo ermöglicht die Nutzung bestimmter weiterer Funktionen, etwa das Bewerten oder Teilen von Videos. Hierzu kann es erforderlich sein, dass Sie sich mit Ihrem Benutzerkonto bei Vimeo oder bestimmten Drittanbietern (wie beispielsweise Facebook oder X) einloggen. Wenn Sie mit Ihrem Browser auch in Ihrem Benutzerkonto von Vimeo oder einem Drittanbieter eingeloggt sind, können die verarbeiteten Informationen abhängig von Ihren Kontoeinstellungen Ihrem Konto hinzugefügt werden. Diese Zuordnung können Sie verhindern, indem Sie sich vor der Nutzung unserer Internetseite aus Ihrem Benutzerkonto des jeweiligen Drittanbieters abmelden. Wir haben darüber hinaus keine Kenntnis, welche weiteren Daten gegebenenfalls durch Vimeo gesammelt und wie diese verarbeitet werden.
                </p>
                <p>Wir haben ein berechtigtes Interesse daran, unsere Website durch die Einbindung von Videos für Sie attraktiver zu gestalten und dabei gleichzeitig unsere Serverinfrastruktur zu entlasten. Die maßgebliche Rechtsgrundlage für die Einbindung der Videos und die damit verbundene Datenverarbeitung durch Vimeo ist insoweit Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                </p>
                <p>Weitere Informationen zur Datenverarbeitung durch Vimeo sowie Ihre diesbezüglichen Rechte und Einstellungsmöglichkeiten zum Schutz Ihrer Privatsphäre erhalten Sie unter:
                </p>
                <ul>
                <li><a href="https://vimeo.com/privacy" target="_blank" rel="noopener" class="module__link--underlined">https://vimeo.com/privacy</a> (Vimeo Privacy Policy)</li>
                <li><a href="https://vimeo.com/cookie_policy?vcid=32179" target="_blank" rel="noopener" class="module__link--underlined">https://vimeo.com/cookie_policy?vcid=32179</a> (Vimeo Cookie Policy)</li>
                <li><a href="https://vimeo.zendesk.com/hc/de/articles/360001494447-Verwendung-von-Player-Parametern" target="_blank" rel="noopener" class="module__link--underlined">https://vimeo.zendesk.com/hc/de/articles/360001494447-Verwendung-von-Player-Parametern</a> (Verwendung von Player-Parametern)</li>
                </ul>
                <span class="video__optin-toggler-wrap">
                <input
                    type="checkbox"
                    id="vimeo__optinout-toggler"
                    class="video__optinout-toggler vimeo__optinout-toggler"
                    name="video__optinout-toggler vimeo__optinout-toggler"
                    data-provider="vimeo"
                    />
                <label
                    class="video__optinout-toggler-label vimeo__optinout-toggler-label"
                    for="vimeo__optinout-toggler"
                    >${uiTextVimeoVideoOptInOut}
                </label>
                </span>
                    `
                    : ''
            }*/

        // ==============================================================
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        //
        // also update tecpage-files/_coming_soon.php
        // when changing the privacy notes
        //
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        // ==============================================================
        html +=
            `
                </div>
                <div class="privacy__legal-text-col module__inner-col module__cms">
                    <h2 class="privacy__title module__title font-h2 color-h2">C. Datenverarbeitung bei einer Kontaktaufnahme</h2>
                    <p>
                    Lesen Sie hier, welche Daten verarbeitet werden, wenn Sie mit uns Kontakt aufnehmen oder Funktionen der Website nutzen.
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">I. Kontaktaufnahme</h3>
                    <p>
                    Wir erheben personenbezogene Daten, wenn Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie uns im Zuge einer Kontaktaufnahme übermitteln.
                    </p>
                    <p>
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. b DSGVO, sofern dies zur Durchführung einer von Ihnen gewünschten Maßnahme erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 S. 1 lit. f DSGVO).
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">II. Werbemaßnahmen</h3>
                    <p>
                    An der Nutzung Ihrer Daten zu Zwecken der Direktwerbung haben wir ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                    </p>
                    <p>
                    <strong>Der Verarbeitung Ihrer personenbezogenen Daten zu Werbezwecken können Sie generell mit Wirkung für die Zukunft schriftlich, per Telefax, per E-Mail oder telefonisch widersprechen. Für den Widerspruch entstehen nur die Übermittlungskosten nach den Basistarifen. </strong>Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt hiervon unberührt.
                    </p>

                    ` +
            (socials.length > 0
                ? `
                    <h2 class="privacy__title module__title font-h2 color-h2">D. Ergänzende Informationen zur Datenverarbeitung auf unseren Social Media Unternehmensseiten</h2>
                    <p>
                    Wir betreiben auf diesen Social-Media-Plattformen eine sogenannte "Unternehmensseite":
                    </p>
                    ` +
                  (socials.length > 0
                      ? `
                    <ul>
                    `
                      : ``) +
                  `
                    ` +
                  (socials.includes('Facebook')
                      ? `
                    <li>Facebook: Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('Instagram')
                      ? `
                    <li>Instagram: Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland</li>`
                      : ``) +
                  `
                     ` /* 2024-06-14: removed +
                  (socials.includes('Twitter')
                      ? `
                    <li>X: Twitter International Unlimited Company, One Cumberland Place, Fenian Street, Dublin 2, D02 AX07, Ireland</li>`
                      : ``) +
                  `
                     ` */ +
                  (socials.includes('LinkedIn')
                      ? `
                    <li>LinkedIn: LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Irland</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('YouTube')
                      ? `
                    <li>YouTube: Google Ireland Limited, Google Building Gordon House, 4 Barrow Street, Dublin, D04 E5W5, Irland</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('Vimeo')
                      ? `
                    <li>Vimeo: Vimeo, Inc., 555 West 18th Street, New York, New York 10011, USA</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('Pinterest')
                      ? `
                    <li>Pinterest: Pinterest Europe Ltd., Waterloo Exchange, 3rd Floor, Waterloo Road, Dublin 4, Irland</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('Xing')
                      ? `
                    <li>Xing: New Work SE, Baumwall 7, 20459 Hamburg, Deutschland</li>`
                      : ``) +
                  `
                     ` +
                  (socials.includes('TikTok')
                      ? `
                    <li>Tik Tok: TikTok Technology Limited, 10 Earlsfort Terrace, Dublin, Irland.</li>`
                      : ``) +
                  `
                    ` +
                  (socials.length > 0
                      ? `
                    </ul>
                    `
                      : ``) +
                  `
                    <p>
                    Ergänzend zu unseren Allgemeinen Informationen (lesen Sie hierzu unter A) informieren wir hier zur Datenverarbeitung beim Besuch auf einer unserer Unternehmensseiten.
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">I. Allgemein zu Unternehmensseiten, Rechtsgrundlage</h3>
                    <p>
                    Als Inhaber einer Online-Präsenz auf einer Social-Media-Plattform verarbeiten wir personenbezogene Daten, wenn Sie uns direkt in einer persönlichen Nachricht oder über die öffentliche Kommentarfunktion über die Plattform anschreiben. Welche Daten erhoben werden, hängt von Ihren Angaben sowie den von Ihnen angegebenen bzw. freigegebenen Kontaktdaten ab. Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. b DSGVO, sofern dies zur Durchführung einer von Ihnen gewünschten Maßnahme erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 S. 1 lit. f DSGVO).
                    </p>
                    <p>
                    Beim Besuch einer Unternehmensseite erhebt der jeweilige Betreiber der Plattform ("Anbieter") Informationen, die es ihm ermöglichen, Nutzer wiederzuerkennen und Nutzerverhalten umfassend zu analysieren. Anhand der so erfassten Daten kann der Anbieter der Social-Media-Plattform zudem Nutzerprofile erstellen. Wenn Sie bei dem Besuch einer Unternehmensseite mit Ihrem entsprechenden Social-Media-Konto eingeloggt sind, kann der jeweilige Anbieter diesen Besuch auch Ihrem Konto zuordnen.
                    </p>
                    <p>
                    Uns stellt der jeweilige Anbieter anhand der gewonnen Informationen lediglich eine anonymisierte statistische Auswertung der Nutzung unserer Unternehmensseite zur Verfügung. So können wir unsere Beiträge künftig noch zielgerichteter gestalten. Insoweit haben wir ein berechtigtes Interesse an der Erhebung und Verarbeitung dieser Informationen. Darüber hinaus haben wir ein berechtigtes Interesse daran, möglichst viele Kommunikationsmöglichkeiten nutzen und damit möglichst viele Interessenten persönlich erreichen zu können. Die Rechtsgrundlage für die mit dem Betrieb einer Unternehmensseite verbundenen Datenverarbeitung ist insoweit Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                    </p>
                    <p>
                    Wir geben selbst keine personenbezogenen Daten an Dritte weiter, die wir über unsere Unternehmensseiten erheben. Wir können aber weder beeinflussen noch ausschließen, dass die genannten Anbieter die erhobenen Daten an Dritte – insbesondere an ihre Partnerunternehmen, die ihren Sitz auch im EU-Ausland haben können – übermitteln. In vielen Drittländern außerhalb der EU besteht derzeit kein der EU entsprechendes Datenschutzniveau.
                    </p>
                    <p>
                    Sie können Ihre Betroffenenrechte (siehe dazu auch unter A.5.) in Bezug auf die Datenverarbeitung durch unsere Unternehmensseiten grundsätzlich sowohl gegenüber uns als auch gegenüber dem jeweiligen Anbieter geltend machen. Wir weisen Sie jedoch darauf hin, dass diese am effektivsten bei dem jeweiligen Anbieter geltend gemacht werden können. Denn nur der jeweilige Anbieter hat Zugriff auf die Daten der Nutzer und kann direkt entsprechende Maßnahmen ergreifen und Auskünfte geben.
                    </p>
                    <p>
                    Weitere Informationen zur Datenverarbeitung durch den jeweiligen Anbieter finden Sie unter:
                    </p>
                    <p>
                    ` +
                  (socials.includes('Facebook')
                      ? `Facebook: <br /><a href="https://de-de.facebook.com/about/privacy" target="_blank">https://de-de.facebook.com/about/privacy</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('Instagram')
                      ? `Instagram: <br />
                         <a href="https://help.instagram.com" target="_blank">https://help.instagram.com</a><br>
                         <a href="https://privacycenter.instagram.com/policy" target="_blank">https://privacycenter.instagram.com/policy</a>
                         <br /><br />`
                      : ``) +
                  `
                    ` /* 2024-06-14: removed +
                  (socials.includes('Twitter')
                      ? `X: <br /><a href="https://x.com/de/privacy" target="_blank">https://x.com/de/privacy</a><br /><br />`
                      : ``) */ +
                  `
                    ` +
                  (socials.includes('LinkedIn')
                      ? `LinkedIn: <br /><a href="https://www.linkedin.com/legal/privacy-policy" target="_blank">https://www.linkedin.com/legal/privacy-policy</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('YouTube')
                      ? `YouTube: <br /><a href="https://www.google.de/intl/de/policies/privacy" target="_blank">https://www.google.de/intl/de/policies/privacy</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('Vimeo')
                      ? `Vimeo: <br /><a href="https://vimeo.com/privacy" target="_blank">https://vimeo.com/privacy</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('Pinterest')
                      ? `Pinterest: <br /><a href="https://policy.pinterest.com/de/privacy-policy" target="_blank">https://policy.pinterest.com/de/privacy-policy</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('Xing')
                      ? `Xing: <br /><a href="https://privacy.xing.com/de/datenschutzerklaerung" target="_blank">https://privacy.xing.com/de/datenschutzerklaerung</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('TikTok')
                      ? `Tik Tok: <br /><a href="https://www.tiktok.com/legal/page/eea/privacy-policy/de-DE" target="_blank">https://www.tiktok.com/legal/page/eea/privacy-policy/de-DE</a>`
                      : ``) +
                  `
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">II. Vereinbarungen nach Art. 26 DSGVO</h3>
                    <p>
                    Einige Anbieter von Social-Media-Plattformen stellen eine Vereinbarung nach Art. 26 DSGVO zur Verfügung, in der die durch den Betrieb unserer Unternehmensseite entstehenden Datenschutzverpflichtungen zwischen uns und dem jeweiligen Anbieter aufgeteilt werden. Die Anbieter haben dabei einen Großteil der datenschutzrechtlichen Verpflichtungen, wie die Erfüllung der Betroffenenrechte nach Art. 12 ff. DSGVO, die Pflicht zur Bereithaltung geeigneter technischer und organisatorischer Maßnahmen zum Schutz der Sicherheit der personenbezogenen Daten sowie die Melde- und Benachrichtigungspflichten im Falle einer Datenschutzverletzung, übernommen. Wenn Sie sich bezüglich Ihrer Betroffenenrechte an uns wenden, leiten wir Ihre Anfrage umgehend an den jeweiligen Anbieter weiter. Hierzu sind wir nach der Vereinbarung mit dem jeweiligen Anbieter verpflichtet.
                    </p>
                    <p>
                    Weitere Informationen zur Vereinbarung zwischen uns und dem jeweiligen Anbieter finden Sie unter:
                    </p>
                    <p>
                    ` +
                  (socials.includes('Facebook')
                      ? `Facebook: <br /><a href="https://www.facebook.com/legal/terms/page_controller_addendum" target="_blank">https://www.facebook.com/legal/terms/page_controller_addendum</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('Instagram')
                      ? `Instagram: <br /><a href="https://www.facebook.com/legal/terms/page_controller_addendum" target="_blank">https://www.facebook.com/legal/terms/page_controller_addendum</a><br /><br />`
                      : ``) +
                  `
                    ` +
                  (socials.includes('LinkedIn')
                      ? `LinkedIn: <br /><a href="https://www.linkedin.com/help/linkedin/answer/124838?lang=de" target="_blank">https://www.linkedin.com/help/linkedin/answer/124838?lang=de</a>`
                      : ``) +
                  `
                    </p>
                    `
                : '') +
            `
                    <h2 class="privacy__title module__title font-h2 color-h2">` +
            (socials.length > 0 ? `E.` : `D.`) +
            ` Ergänzende Informationen für Bewerber</h2>
                    <p>
                    Ergänzend zu unseren Allgemeinen Informationen (lesen Sie hierzu unter A) informieren wir hier, wie personenbezogene Daten unserer Bewerber erhoben und zu welchen Zwecken sie mit welcher Rechtsgrundlage verarbeitet werden. Wir informieren außerdem darüber, wann Bewerberdaten wieder gelöscht werden.
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">I. Zweck und Rechtsgrundlage der Verarbeitung personenbezogener Daten unserer Bewerber</h3>
                    <p>
                    Die persönlichen Daten, die Sie uns im Rahmen des Bewerbungsverfahrens freiwillig mitteilen – wie insbesondere Vor- und Nachname, Anschrift, E-Mail-Adresse, Geburtsdatum, Geburtsort, Beruf, Lebenslauf, Zeugnisse und besondere Kategorien personenbezogener Daten (z.B. Angaben zu Ihrer religiösen Überzeugung oder Gesundheitsdaten) – werden bei uns gespeichert und verarbeitet. Während des Bewerbungsverfahrens können zusätzliche, für die Bewerbung relevante Daten anfallen, die ebenfalls gespeichert und verarbeitet werden. Ihre personenbezogenen Daten werden nur zur Durchführung des Bewerbungsverfahrens verarbeitet. Rechtsgrundlage der Datenverarbeitung ist insoweit § 26 Abs. 1 S. 1 Bundes&shy;daten&shy;schutz&shy;gesetz (BDSG) sowie Art. 6 Abs. 1 S. 1 lit. b DSGVO. Im Falle einer erfolgreichen Bewerbung werden die Daten zur Durchführung des Beschäftigtenverhältnisses in Ihre Personalakte übernommen, § 26 Abs. 1 S. 1 BDSG sowie Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                    </p>
                    <h3 class="privacy__subtitle module__subtitle font-h3 color-h3">II. Löschung von Bewerberdaten</h3>
                    <p>
                    Sollte Ihre Bewerbung nicht erfolgreich sein, werden Ihre personenbezogenen Daten spätestens sechs Monate nach Beendigung des Bewerbungsverfahrens gelöscht, es sei denn, die Verarbeitung Ihrer Daten ist erforderlich zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (vgl. Art. 17 Abs. 3 lit. e DSGVO).
                    </p>
                    <p>
                    Eine über das konkrete Bewerbungsverfahren hinausgehende Verarbeitung Ihrer Daten erfolgt nur, wenn Sie ausdrücklich eingewilligt haben, dass Ihre Daten auch nach Ablauf des jeweiligen Bewerbungsverfahrens in unserer Datenbank gespeichert bleiben, damit Sie gegebenenfalls zu einem späteren Zeitpunkt bei offenen Stellen von uns kontaktiert werden können. Falls wir Sie nicht mehr kontaktieren sollen, können Sie Ihre Einwilligung jederzeit mit Wirkung für die Zukunft schriftlich, per E-Mail oder telefonisch widerrufen. Ansonsten werden wir Ihre Daten nach zwei Jahren löschen. Kontaktieren wir Sie innerhalb dieser Frist bezüglich neuer Stellen, beginnt diese Frist jedes Mal neu.
                    </p>
                </div>
            </div>
                    `;
        dom.innerHTML = html;
        // ==============================================================
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        //
        // also update tecpage-files/_coming_soon.php
        // when changing the privacy notes
        //
        // ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️   ⚠️
        // ==============================================================
    }
}
